import request from '@/config/axios'
import type { PageParam } from '@/types/common'
import type { PageResult } from '@/api/lawyer'

export interface FirmRetainerVO {
  id?: number
  customerId: number
  caseId?: number
  title: string
  annualFee: number
  startDate: string
  endDate: string
  status?: string
  leadLawyerId?: number
  customerName?: string
  remark?: string
}

export interface FirmRetainerLogVO {
  id?: number
  retainerId: number
  serviceDate: string
  content: string
  lawyerId?: number
  hours?: number
}

export interface FirmFinanceSummaryVO {
  receiptTotal: number
  receivableTotal: number
  invoiceTotal: number
  refundTotal: number
  commissionTotal: number
  netCash: number
}

export const FirmRetainerApi = {
  create: (data: FirmRetainerVO) => request.post({ url: '/lawyer/firm/retainer/create', data }),
  update: (data: FirmRetainerVO) => request.put({ url: '/lawyer/firm/retainer/update', data }),
  terminate: (id: number) => request.put({ url: '/lawyer/firm/retainer/terminate?id=' + id }),
  page: (params: PageParam & { customerId?: number; status?: string }) =>
    request.get<PageResult<FirmRetainerVO>>({ url: '/lawyer/firm/retainer/page', params }),
  createLog: (data: FirmRetainerLogVO) =>
    request.post({ url: '/lawyer/firm/retainer/service-log/create', data }),
  listLogs: (retainerId: number) =>
    request.get<FirmRetainerLogVO[]>({
      url: '/lawyer/firm/retainer/service-log/list',
      params: { retainerId }
    })
}

export const FirmFinanceApi = {
  summary: (params?: { begin?: string; end?: string }) =>
    request.get<FirmFinanceSummaryVO>({ url: '/lawyer/firm/finance/summary', params }),
  exportUrl: (type = 'summary') =>
    import.meta.env.VITE_BASE_URL +
    import.meta.env.VITE_API_URL +
    `/lawyer/firm/finance/export?type=${type}`
}
